import { useEffect, useState } from 'react';

import { classname } from 'tailwindcss-class-parser'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, tailwindColors } from 'twyne-new.ui'

import PaletteColors from '@/components/builder/properties/Color/Palette';

import FormatterIcon from '../../components/FormatterIcon';
import { useBubbleTiptap } from '../Bubble';

export default function NewColorFormatter({ value, onClick, icon: Icon, tooltipText }) {
  const [color, setColor] = useState()
  const [open, setOpen] = useState(false)
  const { setBubblePopover } = useBubbleTiptap()

  useEffect(() => {
    setBubblePopover && setBubblePopover(open)
  }, [open, setBubblePopover])

  useEffect(() => {
    if (value === undefined && color) {
      setColor()
    }
  }, [value, color])

  const handleChange = newColor => {
    setColor(newColor)
    onClick(newColor)
  }

  const className = value ? classname({ ...value }) : ''
  const style = getColorPreviewStyle(value)

  return <>
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger>
        <FormatterIcon
          icon={Icon}
          tooltipText={tooltipText}
          className={className}
          style={style}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-[270px]'>
        <PaletteColors value={color} onChange={handleChange} />
      </DropdownMenuContent>
    </DropdownMenu>
  </>
}

const getColorPreviewStyle = value => {
  if (!value) return undefined

  const color = parseColorValue(value?.value)
  if (!color) return undefined

  if (value?.property === 'backgroundColor') {
    return { backgroundColor: color }
  }

  if (value?.property === 'textColor') {
    return { color }
  }

  return undefined
}

const parseColorValue = rawValue => {
  if (typeof rawValue !== 'string' || !rawValue) return undefined

  if (rawValue.startsWith('#') || rawValue.startsWith('rgb') || rawValue.startsWith('hsl')) {
    return rawValue
  }

  return tailwindColors[rawValue]
}
